import { IConflictMark, ItemResponse } from '../item-write/item.models';
import { IAttributeLookups, comparable, diffConflicts } from '../item-write/rules/item-write-concurrency';

/**
 * A 412 on a listing row (HUBX-8478; design "Listing - shared write rules", block B).
 *
 * The comparison and the marking rule are the Edit modal's (item-write-concurrency): with
 * `baseline` as what the row was read as, `currentState` as what the server now holds and
 * `edited` as the row's edit, a member is marked when the other writer moved it AND saving
 * would move it again. On the row the edit IS an ItemResponse, so it is compared as it stands.
 *
 * Marks only (HUBX-8466, 2026-10-19). The row is no longer rebased onto `currentState`: it
 * keeps its baseline, its tokens and its edit, Save stays blocked, and the user resolves the
 * conflict in the resolve popup against the item as re-read (item-write-resolve.rules).
 *
 * Without `currentState` (the server could not re-read) there is nothing to mark; the surface
 * still says the row conflicted.
 */
export function rowConflictMarks(
  baseline: ItemResponse,
  edited: ItemResponse,
  currentState: ItemResponse | null | undefined,
  lookups: IAttributeLookups
): Map<string, IConflictMark> {
  if (!currentState) {
    return new Map();
  }
  const before = comparable(baseline, baseline.effectiveStatus, lookups);
  const after = comparable(currentState, currentState.effectiveStatus, lookups);
  const mine = comparable(edited, edited.effectiveStatus, lookups);
  return diffConflicts(before, after, mine);
}
